import React from 'react'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from './LanguageSwitcher'

export default function PatternBg({children}){
  const { t } = useTranslation()
  return (
    <div className="relative">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(1200px_600px_at_10%_-40%,rgba(30,77,183,.12),transparent_60%),radial-gradient(700px_400px_at_120%_10%,rgba(107,79,42,.10),transparent_60%)]"></div>
      {children}
    </div>
  )
}
